import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';

import TkForm from '@/../bower_components/teknisavuecomponents/components/TkForm.vue';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';
import FileUtils from '@/../bower_components/teknisavuecomponents/assets/utils/FileUtils';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import CommonRequests from '@/assets/ts/controller/CommonRequests';
import Field from '@/../bower_components/teknisavuecomponents/assets/interfaces/Field';
import DateUtil from '@/../bower_components/teknisavuecomponents/assets/utils/DateUtil';
import Estrutura from '@/../bower_components/teknisavuecomponents/assets/interfaces/Estrutura';
import UtilPG from '@/assets/ts/utils/Util';
import { differenceInDays, format, parse } from 'date-fns';
import ParallelRequestHandler from '@/assets/ts/utils/ParallelRequestHandler';
import Dictionary from 'bower_components/teknisavuecomponents/assets/interfaces/Dictionary';
import NovoMedicoPopup from '@/components/NovoMedicoPopup/NovoMedicoPopup.vue';

@Component({
  name: 'NovaOcorrenciaPopup',
  components: {
    TkForm,
    NovoMedicoPopup
  },
})
class NovaOcorrenciaPopup extends Vue {
  // #region [ PROPS ]
  @Prop({ default: false })
  private readonly value: boolean;

  @Prop({ default: null })
  private readonly nrVinculomProp: any;

  @Prop({ default: null })
  private readonly rowsProp: any;
  // #endregion

  // #region [ EVENTS ]
  @Emit('after-save')
  private emitAfterSave() {}

  @Emit('input')
  private emitInput(show: boolean) {}
  // #endregion

  // #region [ STORE ]
  private get user() {
    return this.$store.getters.user;
  }

  private get estruturaGerencialAtual(): Estrutura {
    return this.$store.getters.estruturaGerencialAtual;
  }

  // #endregion

  // #region [ DATA ]
  private internalValue = false;

  private loading = false;

  private fileBase64 = '';
  private loadingFile = false;

  private vinculos: any[] = null;
  private motivosOcor: any[] = null;
  private tiposOcor: any[] = null;
  private horarios: any[] = null;
  private pessoasConseReg: any[] = null;
  private situFreqs: any[] = null;
  public showNovoMedicoPopup=false;

  private resetDates = false;

  private row: Dictionary<any> = {};

  private defaultRow = {
    __is_new: true,
    CDAUTOCOR: 'N'
  };

  private fieldItems = {
    NMDIAGNOST: [],
  };

  // #endregion

  // #region [ COMPUTED ]
  private get genericFilter() {
    const filter = {
      NRORG: this.user.nrorg,
      CDOPERADOR: this.user.cdoperador,
    };

    return filter;
  }

  private get motivoOcorrenciaObrigaDiaOcorre() {
    return this.row.NRMOTIVOOCORFREQ == '14' || this.row.NRMOTIVOOCORFREQ == '31';
  }

  private get cadastroAutomatico() {
    return this.row.CDAUTOCOR == 'S';
  }

  private get fields(): Field[] {
    const fields: Field[] = [
      {
        name: 'NRVINCULOM',
        label: 'Vínculo',
        size: 6,
        type: 'autocomplete',
        valueField: 'NRVINCULOM',
        descriptionField: 'NMVINCULOM',
        items: this.vinculos,
        required: !this.nrVinculomProp,
        isVisible: !this.nrVinculomProp
      },
      {
        name: 'CDAUTOCOR',
        label: 'Cadastro Automático',
        type: 'radio',
        valueField: 'value',
        outData: {
          DSAUTOCOR: 'label',
        },
        items: [
          {
            label: 'Por Lista de Dias',
            value: 'S',
          },
          {
            label: 'Por Intervalo de Dias',
            value: 'N',
          },
        ],
        size: (this.nrVinculomProp && !this.cadastroAutomatico) ? 12 : 6,
        onInput: this.changeCadAutOcor
      },
      {
        name: 'DTMULTIPLASOCORRENCIAS',
        label: 'Lista de Dias Ocorrência',
        size: 12,
        type: 'dateMultiple',
        reset: this.resetDates,
        required: this.cadastroAutomatico,
        isVisible: this.cadastroAutomatico
      },
      {
        name: 'IDTIPODIACALENDARIO',
        label: 'Tipo do Dia',
        size: 6,
        type: 'select',
        valueField: 'IDTIPODIACALENDARIO',
        descriptionField: 'DSTIPODIACALENDARIO',
        items: [
          {
            DSTIPODIACALENDARIO: 'Feriado',
            IDTIPODIACALENDARIO: 'FERIADO',
          },
          {
            DSTIPODIACALENDARIO: 'Ponto Facultativo',
            IDTIPODIACALENDARIO: 'PONTOFACULTATIVO',
          },
        ],
      },
      {
        name: 'IDTIPOHORARIO',
        label: 'Tipo do Horário',
        size: 6,
        type: 'select',
        valueField: 'IDTIPOHORARIO',
        descriptionField: 'NMTIPOHORARIO',
        items: [
          {
            NMTIPOHORARIO: 'Folga',
            IDTIPOHORARIO: 'F',
          },
          {
            NMTIPOHORARIO: 'Compensado',
            IDTIPOHORARIO: 'C',
          },
          {
            NMTIPOHORARIO: 'Normal',
            IDTIPOHORARIO: 'N',
          },
          {
            NMTIPOHORARIO: 'Turno',
            IDTIPOHORARIO: 'T',
          },
        ],
      },
      {
        name: 'NRMOTIVOOCORFREQ',
        label: 'Motivo de Ocorrência',
        size: 6,
        type: 'select',
        valueField: "NRMOTIVOOCORFREQ",
        descriptionField: "DSMOTIVOOCORFREQ",
        items: this.motivosOcor,
        required: true,
        outData: {
          NRMOTIVOOCORFREQ: 'NRMOTIVOOCORFREQ',
          IDANEXOOBRIGATORIO: 'IDANEXOOBRIGATORIO',
        },
      },
      {
        name: 'NRTIPOPROGOCORRENCIA',
        label: 'Tipo de Ocorrência',
        size: 6,
        type: 'select',
        valueField: "NRTIPOPROGOCORRENCIA",
        descriptionField: "NMTIPOPROGOCORRENCIA",
        items: this.tiposOcor,
        required: true,
      },
      {
        name: 'DTINICIOPROGOCOR',
        label: 'Início Ocorrência',
        size: 4,
        type: 'date',
        required: !this.cadastroAutomatico,
        isVisible: !this.cadastroAutomatico
      },
      {
        name: 'DIAOCORRE',
        label: 'Dias Ocorrência',
        type: 'number',
        size: 4,
        required:  !(this.cadastroAutomatico || this.motivoOcorrenciaObrigaDiaOcorre),
        isVisible: !this.cadastroAutomatico
      },
      {
        name: 'DTFIMPROGOCOR',
        label: 'Fim Ocorrência',
        type: 'text',
        size: 4,
        readonly: !this.cadastroAutomatico,
        isVisible: !this.cadastroAutomatico
      },
      {
        name: 'NRHORDIAM',
        label: 'Horário',
        size: 6,
        readonly: false,
        type: 'autocomplete',
        valueField: 'NRHORDIAM',
        descriptionField: 'NMHORDIAH',
        items: this.horarios,
      },
      {
        name: 'QTMINIMAPROGOCOR',
        label: 'Mínimo Horas',
        size: 3,
        type: 'text',
        mask: '##:##',
        onInput: () => this.formatHours('QTMINIMAPROGOCOR')
      },
      {
        name: 'QTMAXIMAPROGOCOR',
        label: 'Máximo Horas',
        size: 3,
        type: 'text',
        mask: '##:##',
        onInput: () => this.formatHours('QTMAXIMAPROGOCOR')
      },
      {
        name: 'CDDIAGNOST',
        label: 'Doença',
        size: 12,
        type: 'autocomplete',
        autocomplete: true,
        valueField: 'CDDIAGNOST',
        descriptionField: 'NMDIAGNOST_VIEW',
        items: this.fieldItems.NMDIAGNOST,
      },
      {
        name: 'NRPESSOA',
        label: 'Médico/Dentista',
        size: 12,
        type: 'autocomplete',
        valueField: 'NRPESSOA',
        descriptionField: 'NMPESSOA_VIEW',
        items: this.pessoasConseReg,
        appendIcon: 'mdi-plus',
        onActionClick:this.openNovoMedicoPopup
      },
      {
        name: 'NRSITUFREQGATILHO',
        label: 'Situação de Frequência do Gatilho ',
        size: 12,
        type: 'select',
        valueField: "NRSITUFREQGATILHO",
        descriptionField: "DSSITUFREQUENCIA_VIEW",
        required: false,
        items: this.situFreqs,
      },
      {
        name: 'QTMINGATILHOPROGOCOR',
        label: 'Qtd. Mínima do Gatilho',
        size: 4,
        type: 'text',
        mask: '##:##',
        onInput: () => this.formatHours('QTMINGATILHOPROGOCOR')
      },
      {
        name: 'QTMAXGATILHOPROGOCOR',
        label: 'Qtd. Máxima do Gatilho',
        size: 4,
        type: 'text',
        mask: '##:##',
        onInput: () => this.formatHours('QTMAXGATILHOPROGOCOR')
      },
      {
        name: 'VRCOEFICIENTEACRESCIMO',
        label: 'Vr. Coeficiente de Acres. (%)',
        size: 4,
        type: 'text',
        onInput: () => this.formatFloatVr()
      },
      {
        name: 'DSOBSERVACAO',
        label: 'Observação',
        size: 12,
        type: 'textarea',
        rows: 2,
        required: true,
      },
      {
        name: 'FILE',
        label: 'Documento',
        size: 12,
        type: 'file',
        required: this.row.IDANEXOOBRIGATORIO === 'S',
      },
    ];

    return fields;
  }
  // #endregion

  //#region [ WATCHERS ]
  @Watch('value', { immediate: true })
  private valueOnChange() {
    this.internalValue = this.value;

    if (this.internalValue) {
      this.row = Util.deepCopy(this.defaultRow);
      this.fileBase64 = '';

      this.row.CDAUTOCOR = 'N';
      this.setOcorrenciaAutomatica();

      if (this.vinculos === null && !this.nrVinculomProp) {
        this.reloadVinculos();
      }
  
      this.reloadFormData();

    }
  }

  @Watch('estruturaGerencialAtual')
  private estruturaGerencialAtualOnChange() {
    this.vinculos = null;
  }
  //#endregion

  // #region [ METHODS ]
  private closeDialog() {
    this.internalValue = false;
    this.resetDates = true;
    this.emitInput(this.internalValue);
  }

  private verifyRequiredFields(): boolean {
    const isValid = this.row.__is_valid;

    if (isValid) {
      return true;
    }

    const message = 'Favor preencher todos os campos obrigatórios!';
    SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ALERT);

    return false;
  }

  private async save() {
    if (!this.verifyRequiredFields()) {
      return;
    }

    if(this.cadastroAutomatico) {
      this.handleSaveMultiple();
      return;
    }

    if (!this.salvarOcorrenciaBeforeInsert()) {
      return;
    }

    try {
      await this.saveOcorrencia();

      this.closeDialog();
      this.emitAfterSave(); 
    } catch (error) {}
  }

  private async saveOcorrencia(isMultiple = false, date = this.row.DTINICIOPROGOCOR) {
    const route = 'setOcorrenciaFreq';

    if (isMultiple) {
      this.row.DTINICIOPROGOCOR = date;
      this.row.DIAOCORRE = 1;
      this.row.DTFIMPROGOCOR = date;
    }

    const params = {
      requestType: 'Row',
      row: {
        NRORG: this.user.nrorg,
        ...this.row,
        FILE: this.fileBase64,
        CDOPERADOR: this.user.cdoperador,
      },
    };

    this.loading = true;

    const diaOcorrencia = isMultiple ? date : this.row.DTINICIOPROGOCOR;

    try {
      const response = await HttpRequest.post(route, params, false);

      if (typeof response.data === 'string') {
        throw new Error(response.data);
      }

      if (response.data.messages) {
        throw new Error(response.data.messages[0].message);
      }

      if (response.data.dataset && response.data.dataset.setOcorrenciaFreq && response.data.dataset.setOcorrenciaFreq.error) {
        SnackbarUtils.showMessage(response.data.dataset.setOcorrenciaFreq.error, SnackbarUtils.TYPE_ALERT);
      }

      const success = response.data.dataset.setOcorrenciaFreq.success;

      if (success) {
        const message = `Ocorrência do dia: ${diaOcorrencia} criada com sucesso!`;
        SnackbarUtils.showMessage(message, 'success', 5000);
      }
    } catch (err) {
      const errorMessage = `Não foi possível criar a ocorrência do dia: ${diaOcorrencia}.`;
      SnackbarUtils.showMessage(errorMessage, 'error', 5000);

      throw err;
    } finally {
      this.loading = false;
    }
  }

  private salvarOcorrenciaBeforeInsert() {
    // Validacao QTMAXIMA e QTMINIMA
    if (this.row.QTMAXIMAPROGOCOR && this.row.QTMINIMAPROGOCOR) {
      const qtMaxima =
      this.row.QTMAXIMAPROGOCOR ? (parseInt(this.row.QTMAXIMAPROGOCOR.replace(':', '')) ? parseInt(this.row.QTMAXIMAPROGOCOR.replace(':', '')) : 0) : 0;

      const qtMinima =
        this.row.QTMINIMAPROGOCOR ? (parseInt(this.row.QTMINIMAPROGOCOR.replace(':', '')) ? parseInt(this.row.QTMINIMAPROGOCOR.replace(':', '')) : 0) : 0;

      if (qtMinima > qtMaxima) {
        SnackbarUtils.showMessage('O mínimo de horas não pode ser maior que o máximo. Faça as alterações e tente novamente.', SnackbarUtils.TYPE_ALERT);
        return false;
      }
    }


    // Gatilho
    if (this.row.QTMAXGATILHOPROGOCOR && this.row.QTMINGATILHOPROGOCOR) {
      this.formatHours('QTMINGATILHOPROGOCOR');
      this.formatHours('QTMAXGATILHOPROGOCOR');

      const qtMaximaGatilho =
      this.row.QTMAXGATILHOPROGOCOR ? (parseInt(this.row.QTMAXGATILHOPROGOCOR.replace(':', '')) ? parseInt(this.row.QTMAXGATILHOPROGOCOR.replace(':', '')) : 0) : 0;
  
      const qtMinimaGatilho =
        this.row.QTMINGATILHOPROGOCOR ? (parseInt(this.row.QTMINGATILHOPROGOCOR.replace(':', '')) ? parseInt(this.row.QTMINGATILHOPROGOCOR.replace(':', '')) : 0) : 0;
  
      if (qtMinimaGatilho > qtMaximaGatilho) {
        SnackbarUtils.showMessage('O mínimo de horas do gatilho não pode ser maior que o máximo. Faça as alterações e tente novamente.', SnackbarUtils.TYPE_ALERT);
        return false;
      }
    }

    if(this.row.VRCOEFICIENTEACRESCIMO) {
      this.parseFloatValue('VRCOEFICIENTEACRESCIMO');
    }

    return true;
  }

  private onFieldInput(fieldName: string, value: any) {
    if (fieldName === 'FILE') {
      if (value instanceof File) {
        this.createBase64File(value);
      } else {
        this.fileBase64 = '';
        this.row.NMFILE = null;
      }
    }

    if (fieldName === 'DIAOCORRE') {
      this.setDtFimOcorre(this.row);
    }

    if (fieldName === 'CDDIAGNOST') {
      this.doencaOnChange(this.row);
    }
  }

  private async createBase64File(file: File) {
    this.loadingFile = true;

    try {
      const fileString = await FileUtils.toBase64(file);
      this.fileBase64 = fileString;
      this.row.NMFILE = file.name;
    } catch (err) {
      const message = 'Não foi possível carregar o arquivo';
      SnackbarUtils.showMessage(message, 'alert', 5000);

      throw err;
    } finally {
      this.loadingFile = false;
    }
  }

  private async reloadVinculos() {
    const vinculos = await CommonRequests.getVinculosDoGestor();
    this.vinculos = vinculos;
  }

  private async getMotivoOcorFreq() {
    const route = "getMotivoOcorFreq";
    const response = await HttpRequest.get(route, {
      requestType: 'FilterData',
      NRORG: this.user.nrorg,
    }, false);

    const rows =
      response.data.dataset.data ||
      response.data.dataset[route] ||
      [];
    
    this.motivosOcor = rows;
  }

  private async getTpOcorrencia() {
    const route = "getTpOcorrencia";
    const response = await HttpRequest.get(route, {
      requestType: 'FilterData',
      NRORG: this.user.nrorg,
    }, false);

    const rows =
      response.data.dataset.data ||
      response.data.dataset[route] ||
      [];
    
    this.tiposOcor = rows;
  }

  private async getHoradiah() {
    const route = "getHoradiah";
    const response = await HttpRequest.get(route, {
      requestType: 'FilterData',
      NRORG: this.user.nrorg,
    }, false);

    const rows =
      response.data.dataset.data ||
      response.data.dataset[route] ||
      [];
    
    this.horarios = rows;
  }

  private async getPessoaConselhoReg() {
    const route = "getPessoaConselhoReg";
    const response = await HttpRequest.get(route, {
      requestType: 'FilterData',
      NRORG: this.user.nrorg,
    }, false);

    const rows =
      response.data.dataset.data ||
      response.data.dataset[route] ||
      [];
    
    this.pessoasConseReg = rows;
  }

  private async getSituFrequencias() {
    const route = "getSituFrequencias";
    const response = await HttpRequest.get(route, {
      requestType: 'FilterData',
      NRORG: this.user.nrorg,
    }, false);

    const rows =
      response.data.dataset.data ||
      response.data.dataset[route] ||
      [];
    
    this.situFreqs = rows;
  }

  private reloadFormData() {
    this.getMotivoOcorFreq();
    this.getTpOcorrencia();
    this.getHoradiah();
    this.getPessoaConselhoReg();
    this.getSituFrequencias();
    this.loadDoenca();
  }

  private setDtFimOcorre(currentRow: any){
    if(currentRow.DTINICIOPROGOCOR && currentRow.DIAOCORRE){
      currentRow.DTFIMPROGOCOR = DateUtil.addDaysDate(currentRow.DTINICIOPROGOCOR, currentRow.DIAOCORRE - 1);
    }
  }

  // Rotina necessaria pois eh necessario manipular os dados do campo NMDIAGNOST
  private doencaOnChange(row) {
    const CIDData = this.fieldItems.NMDIAGNOST;
    const rowCDDIAGNOST = row.CDDIAGNOST;
    if (!rowCDDIAGNOST) {
      return;
    }
    
    const doencaData = CIDData.find((item) => item.CDDIAGNOST === rowCDDIAGNOST);
    if (!doencaData) {
      row.CDTABECDI = null;
      return;
    }
    
    row.CDTABECDI = doencaData.CDTABECDI;
  }

  private async loadDoenca() {
    // Request doencas
    if (!this.fieldItems.NMDIAGNOST || (Array.isArray(this.fieldItems.NMDIAGNOST) && this.fieldItems.NMDIAGNOST.length === 0)) {
      try {
        const response = await HttpRequest.get('getDiagnost', {
          requestType: 'FilterData',
          NRORG: this.user.nrorg,
        }, false);
  
        if (typeof response.data === 'string') {
          throw new Error(response.data);
        }

        this.fieldItems.NMDIAGNOST = response.data.dataset.data;
      } catch (err) {
        const message = 'Não foi possível carregar as informações de doença.';
        SnackbarUtils.showMessage(message, 'error');
  
        throw err;
      }
    }
  }

  private formatFloatVr() {
    const value = this.row.VRCOEFICIENTEACRESCIMO;
    if(!value) return;

    let floatValue = parseFloat(value.replace(',', '.'));

    if (isNaN(floatValue)) {
      floatValue = 0;
    }

    const valueFormatted = floatValue.toFixed(5).replace('.', ',');

    this.$nextTick(() => {
      const rowCopy = Util.deepCopy(this.row);
      this.row = {...rowCopy, VRCOEFICIENTEACRESCIMO: valueFormatted };
    });
  }

  private parseFloatValue(key: string) {
    const value = this.row[key];
    if(!value) return;
  
    const floatValue = parseFloat(value.replace(',', '.'));
  
    if (isNaN(floatValue)) {
      return 0;
    }
    
    this.row[key] = floatValue;
  }

  private formatHours(key: string) {
    // Formata a saída como "HH:MM"
    const horas = UtilPG.formatHours(this.row[key]);

    this.$nextTick(() => {
      this.row[key] = horas;
      const rowCopy = Util.deepCopy(this.row);
      this.row = { ...rowCopy };
    });
  }

  private async handleSaveMultiple() {

    await this.saveMultiple();

    this.closeDialog();
    this.emitAfterSave();

  }

  private async saveMultiple() {
    const dates = this.row.DTMULTIPLASOCORRENCIAS.split(', ');
  
    // Crie uma lista de promessas para todas as datas
    const promessas = dates.map((date: string) => this.saveOcorrencia(true, date));
    
    try {
      // Execute todas as promessas em paralelo
      await Promise.all(promessas);      
    } catch (error) {
      return false;
    }
  }

  private async getMarcacoesDia(data = this.row.DTINICIOPROGOCOR) {
    const param = {
      requestType: 'Row',
      NRORG: this.user.nrorg,
      row: {
        NRORG: this.user.nrorg,
        NRVINCULOM: this.row.NRVINCULOM,
        DTINICIOPROGOCOR: data,
        QTDDIAOCORRE: this.row.DIAOCORRE,
        FILE: this.fileBase64,
        CDOPERADOR: this.user.cdoperador,
      },
    };
  
    try {
      const possuiMarcacoes = await HttpRequest.post('getMarcacoesDia', param, true);
      
      if (Util.isEmptyOrBlank(possuiMarcacoes.data.dataset.data)) {
        SnackbarUtils.showMessage(`Não é possível registrar este tipo de ocorrência para o dia selecionado, pois não há marcações registradas.`, SnackbarUtils.TYPE_ALERT);
        return false;
      }
  
      return true;
    } catch (error) {
      console.error('Erro ao buscar marcações para a data:', data, error);
      SnackbarUtils.showMessage('Ocorreu um erro ao buscar marcações.', SnackbarUtils.TYPE_ERROR);
      return false;
    }
  }

  private async getMarcacoesDiaMultiple() {
    const dates = this.row.DTMULTIPLASOCORRENCIAS.split(', ');
  
    // Crie uma lista de promessas para todas as datas
    const promessas = dates.map((date: string) => this.getMarcacoesDia(date));
    
    try {
      // Execute todas as promessas em paralelo
      const resultados = await Promise.all(promessas);
  
      // Verifique se algum resultado é false
      const todasMarcacoesPresentes = resultados.every(resultado => resultado === true);
      
      if (todasMarcacoesPresentes) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error('Erro ao buscar marcações para múltiplas datas:', error);
      SnackbarUtils.showMessage('Ocorreu um erro ao buscar marcações para múltiplas datas.', SnackbarUtils.TYPE_ERROR);
      return false;
    }
  }

  private setOcorrenciaAutomatica() {
    if(!this.rowsProp || !this.nrVinculomProp) return;

    const diasOcorrencia = this.rowsProp.map(item => item.DIA).join(', ');

    this.row.NRVINCULOM = this.nrVinculomProp;
    this.row.CDAUTOCOR = 'S';
    this.row.DTMULTIPLASOCORRENCIAS = diasOcorrencia;
  }

  private changeCadAutOcor(value: string) {
   if(value == 'N') {
    this.$nextTick(() => {
      const rowCopy = Util.deepCopy(this.row);
      this.row = {...rowCopy, DTMULTIPLASOCORRENCIAS: '' };
    });
   }
  }
  public openNovoMedicoPopup(){
    this.showNovoMedicoPopup = true;
  }
  public async medicoAfterSave(medico: any) {
    try {
      // Recarregar especificamente a lista de médicos
      await this.getPessoaConselhoReg();
    
      // Mostrar mensagem de sucesso
      SnackbarUtils.showMessage(`Médico "${medico.NMPESSOA}" cadastrado com sucesso!`, 'success');
    
    } catch (error) {
      console.error('Erro ao atualizar lista de médicos:', error);
      SnackbarUtils.showMessage('Médico cadastrado, mas houve erro ao atualizar a lista', 'warning');
    }
  }
  private mounted(){
    try {
    this.getPessoaConselhoReg();
  } catch (error) {
    console.error('Erro ao carregar médicos no mounted:', error);
    SnackbarUtils.showMessage('Erro ao carregar lista de médicos', 'error');
  }
  }
  // #endregion
}

export default NovaOcorrenciaPopup;